(function () {
  const STYLE_LABELS = {
    fresco: 'Fresco y limpio',
    dulce: 'Dulce y adictivo',
    elegante: 'Elegante y sofisticado',
    seductor: 'Sensual y seductor',
    intenso: 'Intenso, con carácter',
    floral: 'Floral y luminoso',
  };

  const OCCASION_LABELS = {
    diario: 'Todos los días',
    cita: 'Cita o momento romántico',
    fiesta: 'Fiesta o salida nocturna',
    especial: 'Ocasión especial',
    versatil: 'Uno que sirva para todo',
  };

  const CLIMATE_LABELS = {
    calor: 'Días cálidos',
    frio: 'Días fríos',
    todo: 'Todo el año',
  };

  const CATALOG = [
    { code: '01', name: 'Sauvage Parfum', brand: 'Dior', audience: 'masculino', lookup: ['sauvage parfum'], exclude: ['elixir'], styles: ['elegante', 'intenso', 'seductor'], occasions: ['versatil', 'cita', 'especial'], climates: ['todo', 'frio'], intensity: 3, profile: 'Amaderado, cálido y refinado', prices: { 3: 9990, 5: 14990, 10: 24990 }, popular: 3 },
    { code: '02', name: 'Sauvage Elixir', brand: 'Dior', audience: 'masculino', lookup: ['sauvage elixir'], styles: ['intenso', 'elegante', 'seductor'], occasions: ['cita', 'fiesta', 'especial'], climates: ['frio'], intensity: 3, profile: 'Especiado, profundo y de gran presencia', prices: { 3: 10990, 5: 16990, 10: 27990 }, popular: 3 },
    { code: '03', name: 'Stronger With You Intensely', brand: 'Emporio Armani', audience: 'masculino', lookup: ['stronger with you intensely'], styles: ['dulce', 'seductor', 'intenso'], occasions: ['cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Dulce, cálido y muy envolvente', prices: { 3: 7990, 5: 12490, 10: 19490 }, popular: 3 },
    { code: '04', name: 'Born in Roma Intense', brand: 'Valentino', audience: 'masculino', lookup: ['born in roma intense'], exclude: ['donna'], styles: ['dulce', 'seductor', 'elegante'], occasions: ['cita', 'fiesta', 'versatil'], climates: ['frio', 'todo'], intensity: 3, profile: 'Avainillado, moderno y seductor', prices: { 3: 9490, 5: 14490, 10: 24990 }, popular: 3 },
    { code: '05', name: 'Le Male Le Parfum', brand: 'Jean Paul Gaultier', audience: 'masculino', lookup: ['le male le parfum'], styles: ['dulce', 'elegante', 'seductor'], occasions: ['cita', 'especial', 'versatil'], climates: ['frio', 'todo'], intensity: 3, profile: 'Cálido, elegante y cremoso', prices: { 3: 8490, 5: 12990, 10: 20990 }, popular: 3 },
    { code: '06', name: 'Le Male Elixir', brand: 'Jean Paul Gaultier', audience: 'masculino', lookup: ['le male elixir'], styles: ['dulce', 'seductor', 'intenso'], occasions: ['cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Dulce, potente y nocturno', prices: { 3: 8990, 5: 13990, 10: 21990 }, popular: 3 },
    { code: '07', name: 'Le Beau EDT', brand: 'Jean Paul Gaultier', audience: 'masculino', lookup: ['le beau edt'], styles: ['fresco', 'seductor', 'dulce'], occasions: ['diario', 'cita', 'versatil'], climates: ['calor', 'todo'], intensity: 2, profile: 'Fresco, tropical y atractivo', prices: { 3: 7990, 5: 12490, 10: 19990 }, popular: 2 },
    { code: '08', name: 'Le Beau Le Parfum', brand: 'Jean Paul Gaultier', audience: 'masculino', lookup: ['le beau le parfum'], styles: ['dulce', 'seductor', 'elegante'], occasions: ['cita', 'fiesta', 'especial'], climates: ['frio', 'todo'], intensity: 3, profile: 'Tropical, intenso y sofisticado', prices: { 3: 8990, 5: 13990, 10: 22990 }, popular: 3 },
    { code: '09', name: 'Bleu de Chanel EDP', brand: 'Chanel', audience: 'masculino', lookup: ['bleu de chanel'], styles: ['fresco', 'elegante'], occasions: ['diario', 'especial', 'versatil'], climates: ['todo', 'calor'], intensity: 2, profile: 'Limpio, elegante y extremadamente versátil', prices: { 3: 9990, 5: 14990, 10: 23990 }, popular: 3 },
    { code: '10', name: 'The Most Wanted Parfum', brand: 'Azzaro', audience: 'masculino', lookup: ['the most wanted parfum'], styles: ['dulce', 'seductor', 'intenso'], occasions: ['cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Cálido, dulce y magnético', prices: { 3: 6990, 5: 11990, 10: 19490 }, popular: 3 },
    { code: '11', name: 'Invictus Victory Elixir', brand: 'Rabanne', audience: 'masculino', lookup: ['invictus victory elixir'], styles: ['dulce', 'intenso', 'seductor'], occasions: ['cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Potente, oscuro y avainillado', prices: { 3: 7990, 5: 12990, 10: 20990 }, popular: 2 },
    { code: '12', name: 'Eros EDP', brand: 'Versace', audience: 'masculino', lookup: ['eros edp'], exclude: ['flame', 'najim'], styles: ['fresco', 'dulce', 'seductor'], occasions: ['fiesta', 'cita', 'versatil'], climates: ['todo'], intensity: 3, profile: 'Fresco, dulce y juvenil', prices: { 3: 6990, 5: 10990, 10: 17990 }, popular: 3 },
    { code: '13', name: 'Eros Flame', brand: 'Versace', audience: 'masculino', lookup: ['eros flame'], styles: ['fresco', 'dulce', 'intenso'], occasions: ['cita', 'fiesta', 'versatil'], climates: ['frio', 'todo'], intensity: 3, profile: 'Cítrico, especiado y cálido', prices: { 3: 6990, 5: 10990, 10: 17990 }, popular: 2 },
    { code: '14', name: 'Eros Najim Parfum', brand: 'Versace', audience: 'masculino', lookup: ['eros najim'], styles: ['intenso', 'elegante', 'dulce'], occasions: ['especial', 'cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Amaderado, especiado y lujoso', prices: { 3: 8490, 5: 12990, 10: 21490 }, popular: 2 },
    { code: '15', name: 'The Most Wanted Intense', brand: 'Azzaro', audience: 'masculino', lookup: ['the most wanted intense'], styles: ['dulce', 'seductor', 'intenso'], occasions: ['cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Dulce, especiado y adictivo', prices: { 3: 6990, 5: 11490, 10: 18990 }, popular: 2 },
    { code: '16', name: 'Scandal Le Parfum', brand: 'Jean Paul Gaultier', audience: 'masculino', lookup: ['scandal le parfum', 'scandal homme le parfum'], styles: ['dulce', 'seductor', 'intenso'], occasions: ['cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Dulce, intenso y llamativo', prices: { 3: 7490, 5: 11990, 10: 19990 }, popular: 2 },
    { code: '17', name: 'MYSLF EDP', brand: 'Yves Saint Laurent', audience: 'masculino', lookup: ['myslf edp', 'myslf'], styles: ['fresco', 'floral', 'elegante'], occasions: ['diario', 'especial', 'versatil'], climates: ['todo', 'calor'], intensity: 2, profile: 'Limpio, floral y moderno', prices: { 3: 8990, 5: 13990, 10: 22490 }, popular: 3 },
    { code: '18', name: 'Gentleman Réserve Privée', brand: 'Givenchy', audience: 'masculino', lookup: ['gentleman reserve privee'], styles: ['elegante', 'dulce', 'intenso'], occasions: ['especial', 'cita'], climates: ['frio'], intensity: 3, profile: 'Cálido, elegante y con carácter', prices: { 3: 8490, 5: 13490, 10: 21990 }, popular: 2 },
    { code: '19', name: 'Acqua di Giò Parfum', brand: 'Giorgio Armani', audience: 'masculino', lookup: ['acqua di gio parfum'], exclude: ['profondo'], styles: ['fresco', 'elegante'], occasions: ['diario', 'especial', 'versatil'], climates: ['calor', 'todo'], intensity: 2, profile: 'Marino, elegante y equilibrado', prices: { 3: 8490, 5: 12990, 10: 21490 }, popular: 2 },
    { code: '20', name: 'Acqua di Giò Profondo Parfum', brand: 'Giorgio Armani', audience: 'masculino', lookup: ['acqua di gio profondo parfum', 'acqua di gio profondo'], styles: ['fresco', 'intenso', 'elegante'], occasions: ['diario', 'versatil', 'especial'], climates: ['calor', 'todo'], intensity: 3, profile: 'Marino, profundo y moderno', prices: { 3: 8490, 5: 12990, 10: 21490 }, popular: 2 },
    { code: '21', name: 'Light Blue Pour Homme', brand: 'Dolce & Gabbana', audience: 'masculino', lookup: ['light blue pour homme'], styles: ['fresco'], occasions: ['diario', 'versatil'], climates: ['calor'], intensity: 2, profile: 'Cítrico, limpio y refrescante', prices: { 3: 6990, 5: 10990, 10: 17990 }, popular: 2 },
    { code: '22', name: 'Ombré Leather EDP', brand: 'Tom Ford', audience: 'unisex', lookup: ['ombre leather'], styles: ['intenso', 'elegante', 'seductor'], occasions: ['especial', 'cita'], climates: ['frio'], intensity: 3, profile: 'Cuero, carácter y sofisticación', prices: { 3: 10990, 5: 17490, 10: 33990 }, popular: 2 },
    { code: '23', name: 'Althaïr', brand: 'Parfums de Marly', audience: 'masculino', lookup: ['althair'], styles: ['dulce', 'elegante', 'intenso'], occasions: ['especial', 'cita'], climates: ['frio'], intensity: 3, profile: 'Avainillado, cálido y de lujo', prices: { 3: 13990, 5: 21990, 10: 39990 }, popular: 2 },
    { code: '24', name: 'Naxos', brand: 'Xerjoff', audience: 'unisex', lookup: ['naxos'], styles: ['dulce', 'elegante', 'intenso'], occasions: ['especial', 'cita'], climates: ['frio'], intensity: 3, profile: 'Dulce, aromático y distinguido', prices: { 3: 10990, 5: 16990, 10: 34990 }, popular: 3 },
    { code: '25', name: 'Erba Pura', brand: 'Xerjoff', audience: 'unisex', lookup: ['erba pura'], styles: ['dulce', 'intenso', 'seductor'], occasions: ['fiesta', 'cita', 'versatil'], climates: ['todo'], intensity: 3, profile: 'Frutal, expansivo y muy duradero', prices: { 3: 12990, 5: 19990, 10: 39990 }, popular: 3 },
    { code: '26', name: 'Torino21', brand: 'Xerjoff', audience: 'unisex', lookup: ['torino21', 'torino 21'], styles: ['fresco', 'elegante'], occasions: ['diario', 'especial', 'versatil'], climates: ['calor', 'todo'], intensity: 2, profile: 'Verde, fresco y refinado', prices: { 3: 12990, 5: 19990, 10: 40990 }, popular: 3 },
    { code: '27', name: 'Donna Born in Roma Intense', brand: 'Valentino', audience: 'femenino', lookup: ['donna born in roma intense'], styles: ['dulce', 'floral', 'seductor'], occasions: ['cita', 'fiesta', 'especial'], climates: ['frio', 'todo'], intensity: 3, profile: 'Floral, avainillado y sensual', prices: { 3: 9490, 5: 14490, 10: 23990 }, popular: 3 },
    { code: '28', name: 'Good Girl EDP', brand: 'Carolina Herrera', audience: 'femenino', lookup: ['good girl edp', 'good girl'], exclude: ['blush'], styles: ['dulce', 'elegante', 'seductor'], occasions: ['cita', 'especial', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Dulce, elegante y atrevido', prices: { 3: 8490, 5: 13490, 10: 21990 }, popular: 3 },
    { code: '29', name: 'Good Girl Blush', brand: 'Carolina Herrera', audience: 'femenino', lookup: ['good girl blush'], styles: ['floral', 'dulce', 'seductor'], occasions: ['diario', 'cita', 'versatil'], climates: ['todo', 'calor'], intensity: 2, profile: 'Floral, delicado y coqueto', prices: { 3: 8990, 5: 13990, 10: 22990 }, popular: 3 },
    { code: '30', name: 'Libre Le Parfum', brand: 'Yves Saint Laurent', audience: 'femenino', lookup: ['libre le parfum'], styles: ['elegante', 'dulce', 'intenso'], occasions: ['especial', 'cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Cálido, floral y sofisticado', prices: { 3: 9490, 5: 14490, 10: 23990 }, popular: 3 },
    { code: '31', name: 'Paradoxe EDP', brand: 'Prada', audience: 'femenino', lookup: ['paradoxe edp', 'paradoxe'], styles: ['floral', 'elegante', 'dulce'], occasions: ['diario', 'cita', 'versatil'], climates: ['todo'], intensity: 2, profile: 'Floral, limpio y moderno', prices: { 3: 8990, 5: 13990, 10: 22990 }, popular: 3 },
    { code: '32', name: 'Black Opium Over Red', brand: 'Yves Saint Laurent', audience: 'femenino', lookup: ['black opium over red', 'black opium edp over red'], styles: ['dulce', 'seductor', 'intenso'], occasions: ['cita', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Cereza, café y vainilla seductora', prices: { 3: 9490, 5: 14490, 10: 23990 }, popular: 3 },
    { code: '33', name: 'La Bomba EDP', brand: 'Carolina Herrera', audience: 'femenino', lookup: ['la bomba edp', 'la bomba'], styles: ['floral', 'dulce', 'seductor'], occasions: ['cita', 'fiesta', 'versatil'], climates: ['todo'], intensity: 3, profile: 'Frutal, floral y vibrante', prices: { 3: 8990, 5: 13990, 10: 22990 }, popular: 2 },
    { code: '34', name: 'J’adore EDP', brand: 'Dior', audience: 'femenino', lookup: ['j adore edp', 'j adore', 'jadore edp', 'jadore'], styles: ['floral', 'elegante'], occasions: ['diario', 'especial', 'versatil'], climates: ['todo', 'calor'], intensity: 2, profile: 'Floral, luminoso y elegante', prices: { 3: 9990, 5: 15490, 10: 24990 }, popular: 3 },
    { code: '35', name: 'Burberry Her EDP', brand: 'Burberry', audience: 'femenino', lookup: ['burberry her edp', 'burberry her'], styles: ['dulce', 'floral'], occasions: ['diario', 'cita', 'versatil'], climates: ['todo'], intensity: 2, profile: 'Frutal, dulce y juvenil', prices: { 3: 8490, 5: 13490, 10: 21990 }, popular: 3 },
    { code: '36', name: 'Divine EDP', brand: 'Jean Paul Gaultier', audience: 'femenino', lookup: ['divine edp', 'gaultier divine'], styles: ['floral', 'elegante', 'dulce'], occasions: ['especial', 'cita', 'versatil'], climates: ['todo'], intensity: 2, profile: 'Floral, luminoso y sensual', prices: { 3: 8990, 5: 13990, 10: 22990 }, popular: 2 },
    { code: '37', name: 'Idôle EDP', brand: 'Lancôme', audience: 'femenino', lookup: ['idole edp', 'idole'], styles: ['floral', 'fresco', 'elegante'], occasions: ['diario', 'versatil'], climates: ['calor', 'todo'], intensity: 2, profile: 'Limpio, floral y luminoso', prices: { 3: 6990, 5: 10990, 10: 17990 }, popular: 2 },
    { code: '38', name: 'La Vie Est Belle EDP', brand: 'Lancôme', audience: 'femenino', lookup: ['la vie est belle'], styles: ['dulce', 'elegante', 'intenso'], occasions: ['cita', 'especial', 'fiesta'], climates: ['frio'], intensity: 3, profile: 'Dulce, elegante y reconocible', prices: { 3: 8490, 5: 13490, 10: 21990 }, popular: 3 },
    { code: '39', name: 'Cloud EDP', brand: 'Ariana Grande', audience: 'femenino', lookup: ['cloud edp', 'ariana grande cloud'], styles: ['dulce', 'seductor'], occasions: ['diario', 'cita', 'versatil'], climates: ['todo', 'frio'], intensity: 2, profile: 'Dulce, cremoso y reconfortante', prices: { 3: 5990, 5: 9990, 10: 16990 }, popular: 3 },
    { code: '40', name: 'Black Opium Le Parfum', brand: 'Yves Saint Laurent', audience: 'femenino', lookup: ['black opium le parfum'], styles: ['dulce', 'seductor', 'intenso'], occasions: ['cita', 'fiesta', 'especial'], climates: ['frio'], intensity: 3, profile: 'Vainilla, café y calidez intensa', prices: { 3: 8990, 5: 13990, 10: 22990 }, popular: 3 },
    { code: '41', name: 'Power of You', brand: 'Emporio Armani', audience: 'femenino', lookup: ['power of you'], styles: ['dulce', 'floral', 'seductor'], occasions: ['diario', 'cita', 'versatil'], climates: ['todo'], intensity: 2, profile: 'Frutal, cremoso y avainillado', prices: { 3: 9490, 5: 14490, 10: 23990 }, popular: 2 },
    { code: '42', name: 'Acqua di Gioia', brand: 'Giorgio Armani', audience: 'femenino', lookup: ['acqua di gioia'], styles: ['fresco', 'floral'], occasions: ['diario', 'versatil'], climates: ['calor'], intensity: 2, profile: 'Acuático, verde y refrescante', prices: { 3: 8490, 5: 13490, 10: 21990 }, popular: 2 },
    { code: '43', name: 'Light Blue Pour Femme', brand: 'Dolce & Gabbana', audience: 'femenino', lookup: ['light blue pour femme'], styles: ['fresco'], occasions: ['diario', 'versatil'], climates: ['calor'], intensity: 2, profile: 'Cítrico, liviano y veraniego', prices: { 3: 6990, 5: 10990, 10: 17990 }, popular: 2 },
    { code: '44', name: 'Bright Crystal Absolu', brand: 'Versace', audience: 'femenino', lookup: ['bright crystal absolu'], styles: ['floral', 'fresco', 'dulce'], occasions: ['diario', 'cita', 'versatil'], climates: ['calor', 'todo'], intensity: 2, profile: 'Frutal, floral y brillante', prices: { 3: 6990, 5: 10990, 10: 17990 }, popular: 2 },
  ];

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function parseJSON(element, fallback) {
    if (!element) return fallback;
    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function formatPrice(value) {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0,
    }).format(value);
  }

  function liquidPriceToCLP(value) {
    const number = Number(value || 0);
    return number >= 100000 ? Math.round(number / 100) : number;
  }

  function escapeHTML(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeImageURL(value) {
    const url = String(value || '');
    return /^(https?:)?\/\//.test(url) ? url : '';
  }

  class MrdPerfumeFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.products = parseJSON(this.querySelector('[data-mrd-products]'), []);
      this.config = parseJSON(this.querySelector('[data-mrd-config]'), {});
      this.answers = this.emptyAnswers();
      this.step = 0;
      this.catalog = this.attachProducts();

      this.views = Array.from(this.querySelectorAll('[data-mrd-view]'));
      this.progressLabel = this.querySelector('[data-mrd-progress-label]');
      this.progressBar = this.querySelector('[data-mrd-progress-bar]');
      this.questionEyebrow = this.querySelector('[data-mrd-question-eyebrow]');
      this.questionTitle = this.querySelector('[data-mrd-question-title]');
      this.questionHelper = this.querySelector('[data-mrd-question-helper]');
      this.options = this.querySelector('[data-mrd-options]');
      this.resultList = this.querySelector('[data-mrd-result-list]');
      this.shareButton = this.querySelector('[data-mrd-share]');

      this.querySelectorAll('[data-mrd-start]').forEach((button) => {
        button.addEventListener('click', () => this.start());
      });
      this.querySelector('[data-mrd-back]')?.addEventListener('click', () => this.goBack());
      this.querySelector('[data-mrd-restart]')?.addEventListener('click', () => this.start());
      this.shareButton?.addEventListener('click', () => this.share());
    }

    emptyAnswers() {
      return { audience: null, style: null, occasion: null, intensity: null, climate: null };
    }

    attachProducts() {
      const normalizedProducts = this.products.map((product) => ({ ...product, normalizedTitle: normalize(product.title) }));
      const used = new Set();

      return CATALOG.map((perfume) => {
        const product = normalizedProducts.find((candidate) => {
          if (used.has(candidate.id)) return false;
          const matches = perfume.lookup.some((term) => candidate.normalizedTitle.includes(normalize(term)));
          const excluded = (perfume.exclude || []).some((term) => candidate.normalizedTitle.includes(normalize(term)));
          return matches && !excluded;
        });

        if (product) used.add(product.id);
        return { ...perfume, product: product || null };
      });
    }

    start() {
      this.answers = this.emptyAnswers();
      this.step = 0;
      this.showView('quiz');
      this.renderQuestion();
      this.scrollToCurrentView();
    }

    showView(name) {
      this.views.forEach((view) => {
        view.hidden = view.dataset.mrdView !== name;
      });
    }

    scrollToCurrentView() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const current = this.views.find((view) => !view.hidden);
      window.requestAnimationFrame(() => current?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }

    goBack() {
      if (this.step === 0) {
        this.showView('intro');
        this.scrollToCurrentView();
        return;
      }

      this.step -= 1;
      this.renderQuestion();
      this.scrollToCurrentView();
    }

    choose(value) {
      const keys = ['audience', 'style', 'occasion', 'intensity', 'climate'];
      this.answers[keys[this.step]] = value;
      this.step += 1;

      if (this.step >= 5) {
        this.renderResults();
        return;
      }

      this.renderQuestion();
      this.scrollToCurrentView();
    }

    questionForStep() {
      const titles = this.config.questions || {};
      const questions = [
        {
          eyebrow: 'Primero, lo esencial',
          title: titles.audience || '¿Para quién buscas el perfume?',
          helper: 'Esto nos ayuda a mostrarte opciones más cercanas a lo que buscas.',
          options: [
            { value: 'masculino', label: 'Perfumes masculinos', detail: 'Aromas creados con perfil masculino' },
            { value: 'femenino', label: 'Perfumes femeninos', detail: 'Aromas creados con perfil femenino' },
            { value: 'cualquiera', label: 'Estoy abierto a todo', detail: 'Incluye también opciones unisex' },
          ],
        },
        {
          eyebrow: 'Tu estilo',
          title: titles.style || '¿Qué quieres transmitir?',
          helper: 'Elige la sensación que más te representa.',
          options: Object.entries(STYLE_LABELS).map(([value, label]) => ({ value, label })),
        },
        {
          eyebrow: 'El momento',
          title: titles.occasion || '¿Cuándo piensas usarlo?',
          helper: 'Puedes elegir la ocasión más importante para ti.',
          options: Object.entries(OCCASION_LABELS).map(([value, label]) => ({ value, label })),
        },
        {
          eyebrow: 'La presencia',
          title: titles.intensity || '¿Cuánto quieres que se note?',
          helper: 'No hay una respuesta correcta: depende de cómo te guste usar perfume.',
          options: [
            { value: 1, label: 'Suave y discreto', detail: 'Que se perciba principalmente de cerca' },
            { value: 2, label: 'Equilibrado', detail: 'Presente, pero fácil de llevar' },
            { value: 3, label: 'Intenso', detail: 'Que deje una impresión clara' },
          ],
        },
        {
          eyebrow: 'El clima',
          title: titles.climate || '¿En qué clima lo usarás más?',
          helper: 'La temperatura puede cambiar mucho cómo se siente un perfume.',
          options: Object.entries(CLIMATE_LABELS).map(([value, label]) => ({ value, label })),
        },
      ];

      return questions[this.step];
    }

    renderQuestion() {
      const question = this.questionForStep();
      if (!question || !this.options) return;

      this.progressLabel.textContent = `Pregunta ${this.step + 1} de 5`;
      this.progressBar.style.width = `${((this.step + 1) / 5) * 100}%`;
      this.questionEyebrow.textContent = question.eyebrow;
      this.questionTitle.textContent = question.title;
      this.questionHelper.textContent = question.helper;
      this.options.replaceChildren();

      question.options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mrd-finder__option';
        button.innerHTML = `
          <span class="mrd-finder__option-dot" aria-hidden="true"></span>
          <span class="mrd-finder__option-copy">
            <strong>${escapeHTML(option.label)}</strong>
            ${option.detail ? `<small>${escapeHTML(option.detail)}</small>` : ''}
          </span>
          <span class="mrd-finder__option-arrow" aria-hidden="true">→</span>
        `;
        button.addEventListener('click', () => this.choose(option.value));
        this.options.appendChild(button);
      });

      this.questionTitle.focus({ preventScroll: true });
    }

    variantFor(perfume, size) {
      if (!perfume.product?.variants?.length) return null;
      const needle = `${size}ml`;
      return perfume.product.variants.find((variant) => normalize(variant.title).replace(/\s/g, '').includes(needle)) || null;
    }

    priceFor(perfume, size) {
      const variant = this.variantFor(perfume, size);
      return variant ? liquidPriceToCLP(variant.price) : perfume.prices[size];
    }

    score(perfume) {
      const answers = this.answers;
      let score = perfume.popular * 0.35;

      if (answers.audience !== 'cualquiera') {
        if (perfume.audience === answers.audience) score += 8;
        if (perfume.audience === 'unisex') score += 5;
      } else {
        score += perfume.audience === 'unisex' ? 4 : 2;
      }

      if (answers.style && perfume.styles.includes(answers.style)) score += 7;
      if (answers.occasion && perfume.occasions.includes(answers.occasion)) score += 5;

      if (answers.intensity) {
        const distance = Math.abs(perfume.intensity - answers.intensity);
        score += distance === 0 ? 4 : distance === 1 ? 1.5 : 0;
      }

      if (answers.climate === 'todo') {
        score += perfume.climates.includes('todo') ? 3 : 1;
      } else if (answers.climate) {
        if (perfume.climates.includes(answers.climate)) score += 3;
        else if (perfume.climates.includes('todo')) score += 2;
      }

      if (answers.style && perfume.styles[0] === answers.style) score += 1.5;
      if (answers.occasion && perfume.occasions[0] === answers.occasion) score += 1;
      if (perfume.product && perfume.product.available === false) score -= 8;
      return score;
    }

    audienceMatches(perfume) {
      const audience = this.answers.audience;
      if (!audience || audience === 'cualquiera') return true;
      return perfume.audience === audience || perfume.audience === 'unisex';
    }

    recommendations() {
      return this.catalog
        .filter((perfume) => this.audienceMatches(perfume))
        .map((perfume) => ({ perfume, score: this.score(perfume) }))
        .sort((a, b) => b.score - a.score || Number(a.perfume.code) - Number(b.perfume.code))
        .slice(0, 3);
    }

    reasonsFor(perfume) {
      const reasons = [];
      if (this.answers.style && perfume.styles.includes(this.answers.style)) reasons.push(STYLE_LABELS[this.answers.style]);
      if (this.answers.occasion && perfume.occasions.includes(this.answers.occasion)) reasons.push(OCCASION_LABELS[this.answers.occasion]);
      if (this.answers.climate && (perfume.climates.includes(this.answers.climate) || perfume.climates.includes('todo'))) reasons.push(CLIMATE_LABELS[this.answers.climate]);
      if (this.answers.intensity === perfume.intensity) {
        reasons.push(this.answers.intensity === 3 ? 'Presencia intensa' : this.answers.intensity === 2 ? 'Intensidad equilibrada' : 'Perfil discreto');
      }
      return reasons.slice(0, 3);
    }

    productURL(perfume, size) {
      const root = this.config.rootUrl || '/';
      const fallback = `${root.replace(/\/$/, '')}/search?q=${encodeURIComponent(`${perfume.brand} ${perfume.name}`)}`;
      const base = perfume.product?.url || fallback;
      const variant = size ? this.variantFor(perfume, size) : null;
      return variant?.id ? `${base}${base.includes('?') ? '&' : '?'}variant=${variant.id}` : base;
    }

    renderResults() {
      const labels = this.config.labels || {};
      const ranks = [labels.bestMatch || 'Tu mejor coincidencia', labels.secondMatch || 'Segunda recomendación', labels.thirdMatch || 'Tercera recomendación'];
      const recommendations = this.recommendations();
      this.currentRecommendations = recommendations;
      this.resultList.replaceChildren();

      recommendations.forEach(({ perfume }, index) => {
        const image = safeImageURL(perfume.product?.image);
        const reasons = this.reasonsFor(perfume);
        const sizeOptions = [3, 5, 10].map((size) => {
          const price = formatPrice(this.priceFor(perfume, size));
          const content = `<span>${size} ml</span><strong>${escapeHTML(price)}</strong>`;

          if (this.config.showProductButton === false) {
            return `<span class="mrd-finder__size-option">${content}</span>`;
          }

          const ariaLabel = `Ver ${perfume.name} en ${size} ml por ${price}`;
          return `<a class="mrd-finder__size-option" href="${escapeHTML(this.productURL(perfume, size))}" aria-label="${escapeHTML(ariaLabel)}">${content}</a>`;
        }).join('');
        const card = document.createElement('article');
        card.className = `mrd-finder__result${index === 0 ? ' mrd-finder__result--best' : ''}`;

        const media = image
          ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(`${perfume.name} de ${perfume.brand}`)}" loading="${index === 0 ? 'eager' : 'lazy'}" width="600" height="600">`
          : '<span class="mrd-finder__result-placeholder" aria-hidden="true">MrD</span>';
        const fairCode = this.config.showFairCode !== false
          ? `<div class="mrd-finder__fair-code"><span>${escapeHTML(labels.fairInstruction || 'Código de referencia')}</span><strong>${escapeHTML(perfume.code)}</strong></div>`
          : '<div></div>';
        const productLink = this.config.showProductButton !== false
          ? `<a class="mrd-finder__product-link" href="${escapeHTML(this.productURL(perfume))}">${escapeHTML(labels.viewProduct || 'Ver y comprar')} <span aria-hidden="true">↗</span></a>`
          : '';

        card.innerHTML = `
          <div class="mrd-finder__result-media">
            ${media}
          </div>
          <div class="mrd-finder__result-body">
            <div class="mrd-finder__result-rank"><span>${escapeHTML(ranks[index])}</span></div>
            <p class="mrd-finder__result-brand">${escapeHTML(perfume.brand)}</p>
            <h3 class="mrd-finder__result-title">${escapeHTML(perfume.name)}</h3>
            <p class="mrd-finder__result-profile">${escapeHTML(perfume.profile)}</p>
            <div class="mrd-finder__result-meta">
              <div class="mrd-finder__reasons">${reasons.map((reason) => `<span>${escapeHTML(reason)}</span>`).join('')}</div>
            </div>
            <p class="mrd-finder__sizes-title">Elige tu tamaño</p>
            <div class="mrd-finder__sizes">${sizeOptions}</div>
            <div class="mrd-finder__result-footer">${fairCode}${productLink}</div>
          </div>
        `;
        this.resultList.appendChild(card);
      });

      this.showView('results');
      this.scrollToCurrentView();
      this.querySelector('[data-mrd-results-title]')?.focus({ preventScroll: true });
    }

    async share() {
      if (!this.currentRecommendations?.length) return;
      const labels = this.config.labels || {};
      const lines = this.currentRecommendations.map(({ perfume }) => {
        const prices = [3, 5, 10]
          .map((size) => `${size} ml ${formatPrice(this.priceFor(perfume, size))}`)
          .join(' · ');
        return `• ${perfume.name} · ${perfume.brand} — ${prices} — Código ${perfume.code}`;
      });
      const text = `Mis recomendaciones MrDecant:\n${lines.join('\n')}\n\nEncuentra el tuyo en MrDecant.`;

      try {
        if (navigator.share) {
          await navigator.share({ title: 'Mis recomendaciones MrDecant', text, url: window.location.href });
          return;
        }

        await navigator.clipboard.writeText(text);
        this.confirmCopied(labels.copied || 'Resultado copiado');
      } catch (error) {
        if (error?.name === 'AbortError') return;
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
        this.confirmCopied(labels.copied || 'Resultado copiado');
      }
    }

    confirmCopied(message) {
      const label = this.shareButton?.querySelector('span:first-child');
      if (!label) return;
      const original = label.textContent;
      label.textContent = message;
      window.setTimeout(() => { label.textContent = original; }, 2200);
    }
  }

  if (!customElements.get('mrd-perfume-finder')) {
    customElements.define('mrd-perfume-finder', MrdPerfumeFinder);
  }
})();
